import React from 'react';

import ArchiveIcon from '@atlaskit/icon/glyph/archive';

import { Header } from '@qality/common-components/src/atoms/Header';

import {
  PreviousTestExecutionsDetailsStyled,
  PreviousTestExecutionsTitleStyled,
} from './PreviousTestExecutions.styled';

type Props = {
  title: string;
  testExecutionDetails: React.ReactNode;
};

export const PreviousTestExecutionsHeader = ({
  title,
  testExecutionDetails,
}: Props): JSX.Element => {
  return (
    <>
      <PreviousTestExecutionsTitleStyled>
        <Header>
          <Header.Icon>
            <ArchiveIcon size='medium' label='ArchiveIcon' />
          </Header.Icon>
          <Header.Text>{title}</Header.Text>
        </Header>
      </PreviousTestExecutionsTitleStyled>

      <PreviousTestExecutionsDetailsStyled>
        {testExecutionDetails}
      </PreviousTestExecutionsDetailsStyled>
    </>
  );
};
